import React, { useId, useState } from "react";
import { IconEye, IconEyeOff } from "@/components/auth/gsdPasswordIcons.jsx";

/**
 * Champ mot de passe GSD avec bascule afficher/masquer.
 * @param {object} props
 */
export function GsdPasswordField({
  id: idProp,
  label,
  value,
  onChange,
  autoComplete = "current-password",
  required = true,
  name,
  disabled = false,
  testIdPrefix = "gsd-password",
  inputTestId,
  toggleTestId,
  showLabel = "Afficher le mot de passe",
  hideLabel = "Masquer le mot de passe",
  className = "cq-login-card__field",
  inputClassName = "cq-login-card__input",
}) {
  const reactId = useId();
  const id = idProp || `pwd-${reactId}`;
  const [visible, setVisible] = useState(false);
  const inputName = name || testIdPrefix;

  return (
    <div className={className}>
      <label className="cq-login-card__label" htmlFor={id}>
        {label}
      </label>
      <div className="gsd-password-field__wrap">
        <input
          id={id}
          name={inputName}
          type={visible ? "text" : "password"}
          autoComplete={autoComplete}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className={`${inputClassName} gsd-password-field__input`}
          data-testid={inputTestId || `${testIdPrefix}-input`}
        />
        <button
          type="button"
          className="gsd-password-field__toggle"
          data-testid={toggleTestId || `${testIdPrefix}-toggle`}
          aria-label={visible ? hideLabel : showLabel}
          aria-pressed={visible}
          disabled={disabled}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? <IconEyeOff /> : <IconEye />}
        </button>
      </div>
    </div>
  );
}
